var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contenedor-grafica-areas-accion row-center"},[_c('div',{staticClass:"contenedor-grafica"},[_c('div',{attrs:{"id":"chartacuerdo","hidden":_vm.actuacionesfiltered.length == 0}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }